<template>
  <template v-if="type === 'bubble'">
    <ul>
      <FlexMessageBubbleTree
        :message="value"
        :selectedNode="selectedNode"
        :selectedPath="selectedPath"
        :bubbleIndex="0"
        :errorPath="errorPath"
        @onSelectNode="selectNode"
        @onHoverNode="(val) => $emit('onHoverNode', val)"
      />
    </ul>
  </template>
  <template v-else>
    <ul>
      <li>
        <div
          :class="[
            selectedPath === 'carousel' ? 'focused' : '',
            errorPath.includes('carousel') ? 'has-error' : '',
          ]"
          @click="selectNode(value, 'carousel')"
        >
          <span class="node-icon">
            <q-icon
              size="xs"
              :name="showChild ? 'arrow_drop_down' : 'arrow_right'"
              @click="showChild = !showChild"
            />
          </span>
          <span>carousel</span>
        </div>
        <ul :style="!showChild ? 'display: none;' : ''">
          <template v-for="(item, index) in value.contents" :key="index">
            <FlexMessageBubbleTree
              :message="item"
              :selectedNode="selectedNode"
              :selectedPath="selectedPath"
              :bubbleIndex="index"
              :errorPath="errorPath"
              @onSelectNode="selectNode"
              @onHoverNode="(val) => $emit('onHoverNode', val)"
            />
          </template>
        </ul>
      </li>
    </ul>
  </template>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan,
  IFlexMessageText,
  IFlexMessageVideo,
} from '@/utils/types'
import FlexMessageBubbleTree from '@/components/common/flex-message/FlexMessageBubbleTree.vue'
import FlexMessageBubble from '@/components/common/flex-message/FlexMessageBubble.vue'

@Options({
  components: { FlexMessageBubble, FlexMessageBubbleTree },
  directives: { maska },
  emits: ['update:modelValue', 'onSelectNode', 'onHoverNode'],
})
export default class FlexMessageTree extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  type!: string

  @Prop()
  errorPath!: string[]

  showChild = true

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble | IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }
}
</script>

<style lang="scss">

</style>
